<script>
  import router from "page";
  import { Router, Link, Route } from "svelte-routing";

  import Home from "./routes/Home.svelte";
  import Unsubscribe from "./routes/Unsubscribe.svelte";
  import Venue from "./routes/Venue.svelte";
  import Header from "./components/Header.svelte";
  import Footer from "./components/Footer.svelte";

  import { user } from "./store.js";
  import { auth } from "./firebase.js";

  export let url = "";
  let page;
  let params;

  window.initMaps = () => {
    const mapsLoadedEvent = new CustomEvent("maps-loaded");
    window.dispatchEvent(mapsLoadedEvent);
  };
</script>

<style>
  .main {
    width: 922px;
    margin: auto;
  }
</style>

<svelte:head>
  <script
    async
    defer
    type="text/javascript"
    src="SQUARE_JS_URL/v2/paymentform">
  </script>
  <script
    src="https://maps.googleapis.com/maps/api/js?key=MAPS_API_KEY&libraries=places&callback=initMaps"
    async
    defer>
  </script>
</svelte:head>

<Header />
<Router {url}>
  <Route path="" component={Home} />
  <Route path="unsubscribe" component={Unsubscribe} />
  <Route path=":slug" let:params>
    <Venue {...params} />
  </Route>
</Router>
<Footer />
